import {css} from 'lit-element'; export default css`.page-title{float:left;font-size:24px;font-weight:700}.page-title-label{display:inline-block}`;
    